import { MessageDescriptor } from "react-intl";

import messages from "../messages";
import { S_CATEGORY_KEY_BY_ID } from "./messageKeys";

import faceAlex from "assets/images/task-creation/sp-face-alex.png";
import faceKarim from "assets/images/task-creation/sp-face-karim.png";
import faceLina from "assets/images/task-creation/sp-face-lina.png";
import faceAnita from "assets/images/task-creation/sp-face-anita.png";

export interface IServiceProviderPin {
  face: string;
  label: string;
}

/**
 * Face and default first name per pin. Order matches `ServiceProviderMap`'s
 * position arrays (Alex, Karim, Lina, Anita): index N here is index N there,
 * on both breakpoints — and pin N shows the sub-category's `price{N + 1}`.
 */
const PIN_PEOPLE = [
  { face: faceAlex, name: "Alex" },
  { face: faceKarim, name: "Karim" },
  { face: faceLina, name: "Lina" },
  { face: faceAnita, name: "Anita" },
];

const priceMessage = (key: string, index: number) =>
  (messages as Record<string, MessageDescriptor>)[
    `taskCreation.description.pins.${key}.price${index + 1}`
  ];

/**
 * Pins for the description screen's map. No sub-category (the category
 * picker): first names. A sub-category (SEM): its prices from `messages.ts`
 * (`taskCreation.description.pins.<key>.price1-4`), or the `default` set when
 * it is not one of the priced ones.
 *
 * TODO(RT-4506): names stay static until the backend can supply nearby
 * service providers.
 */
export const getServiceProviderPins = (
  sCategoryId: number | undefined,
  formatMessage: (descriptor: MessageDescriptor) => string
): IServiceProviderPin[] => {
  if (sCategoryId === undefined)
    return PIN_PEOPLE.map(({ face, name }) => ({ face, label: name }));

  const key = S_CATEGORY_KEY_BY_ID[sCategoryId] ?? "default";

  return PIN_PEOPLE.map(({ face }, index) => ({
    face,
    label: formatMessage(priceMessage(key, index)),
  }));
};
